import icFileDown from 'assets/images/ic-file-down-02.svg'
import icFileUp from 'assets/images/ic-file-up-02.svg'
import Button from 'components/commons/button'
import { ExportModal } from 'components/commons/ExportModal'
import { InlineTabs } from 'components/commons/InlineTabs'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import Toast from 'components/commons/toast'
import ViewList from 'components/commons/view-list'
import { PreviewInternalMovement } from 'components/hr-metrics/internal-movement/PreviewInternalMovement'
import { TABLE_INTERNAL_MOVEMENT_LIST } from 'configs/hr-metrics/configTableInternalMovementList'
import { ImportInternalMovementContainer } from 'containers/hr-metrics/internal-movement/ImportInternalMovementContainer'
import { InternalMovementFilterContainer } from 'containers/hr-metrics/internal-movement/InternalMovementFilterContainer'

export const InternalMovementList = ({
    dataList,
    dataPreview,
    isLoading,
    isLoadingPreview,
    query,
    queryFilter,
    tabStatus,
    status,
    toast,
    modal,
    selectedIds,
    setShowModal,
    setSelectedIds,
    clearToast,
    onChangeTab,
    onChangeQuery,
    onClickItemHandler,
    onExportHandler,
    onHideImport,
}) => {
    return (
        <div className={'flex flex-col'}>
            <InlineTabs tabList={tabStatus} activeTab={status} onClickTab={onChangeTab} />
            <div className={'flex px-6 py-4 gap-3'}>
                <Search onSearch={(search) => onChangeQuery({ page: 1, search })} value={query?.search} />
                <InternalMovementFilterContainer
                    queryFilter={queryFilter}
                    onSubmit={(queryFilter) => onChangeQuery({ ...queryFilter, page: 1 })}
                />
                <ViewList
                    show={modal?.limit}
                    onShow={() => setShowModal({ limit: true })}
                    onClose={() => setShowModal({ limit: false })}
                    value={query?.limit}
                    onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                />
                <Button 
                    title='Export' 
                    icon={icFileUp} 
                    type='outline' 
                    disabled={!dataList?.total_result}
                    onClick={() => setShowModal({ export: true })} 
                />
                <Button
                    title='Import'
                    icon={icFileDown}
                    type='outline'
                    onClick={() => setShowModal({ import: true })}
                />
            </div>

            <Table
                className='my-3'
                name={TABLE_INTERNAL_MOVEMENT_LIST.name}
                columns={TABLE_INTERNAL_MOVEMENT_LIST.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickSort={(val) => onChangeQuery(val)}
                onClickItem={onClickItemHandler}
                onSelectItem={setSelectedIds}
                loading={isLoading}
            />

            <PreviewInternalMovement
                show={modal?.preview}
                onHide={() => setShowModal({ preview: false })}
                isLoading={isLoadingPreview}
                data={dataPreview}
            />

            <ExportModal
                title='Apakah anda yakin ingin export data internal movement ?'
                description={`Total data internal movement export: ${selectedIds?.length || dataList?.total_result}`}
                show={modal.export}
                onExportHandler={onExportHandler}
                onCancelHandler={() => setShowModal({ export: false })}
            />

            <Toast show={toast?.isShowToast} message={toast?.message} onClose={() => clearToast()} />

            <ImportInternalMovementContainer show={modal?.import} onHide={onHideImport} />
        </div>
    )
}
